// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2waPL","newExpiryDate":"styles_newExpiryDate__wwFsu","footer":"styles_footer__2lbiX"};